export default __webpack_public_path__ + "static/media/marazzi_480x480.c77499ba.png";